import { defaultLocale } from './clientLocale';

export function buildRoute(path: string, lang: string) {
  if (lang === defaultLocale || path.startsWith('http') || path.startsWith(`/${lang}`)) return path.toLowerCase();

  return `/${lang}${path.startsWith('/') ? path : `/${path}`}`.toLowerCase();
}
